module.exports = __webpack_public_path__ + "static/Squat-it-58373520e9bb44f900909969779720d1.mp4";